import axios from "../../utils/axios";
import type { SectorDTO } from "../types/lookupDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchAllSectors = () => axios.get<SectorDTO[]>(`${apiUrl}/Sector/GetAll`);

const sectorService = {
  fetchAllSectors,
};

export default sectorService;
